if (!window.json_url) {
  window.json_url = 'http://localhost/judas/judastad_6m_imob_secovi/wp-content/plugins/tirechvue/cadastro/json/'
}
import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue                    from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import './plugins/veeValidate'
import App                    from './App.vue'
// import './registerServiceWorker'
import router                 from './router'
import store                  from './store'
// import VeeValidate from 'vee-validate';
// import { ValidationProvider } from 'vee-validate';
import VueTheMask             from 'vue-the-mask'
//https://logaretm.github.io/vee-validate/guide/3rd-party-libraries.html#bootstrapvue
import { ValidationObserver, ValidationProvider } from "vee-validate";
//https://logaretm.github.io/vee-validate/guide/rules.html#importing-rules-in-nuxt-js
//https://codesandbox.io/s/veevalidate-components-vuetify-pij6w?from-embed

Vue.use(VueTheMask)

//https://logaretm.github.io/vee-validate/advanced/programmatic-validation.html#validation-options
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Vue.use(VeeValidate);

Vue.config.productionTip = false


new Vue({
          router,
          store,
          render: h => h(App)
      }).$mount('#app');
